// F.17: pliki certyfikatu i klucza KSeF wybrane w Ustawieniach KSeF. Aplikacja Podatnika KSeF
// daje certyfikat jako .crt (PEM, tekst), część programów jako .cer (DER, bajty), a klucz jako
// .key (PEM). Tekst PEM wysyłamy jak jest, bajty w base64, a serwer rozpoznaje oba
// (Login/backend/lib/ksefCert.js). Plik nie opuszcza przeglądarki inaczej niż w zapisie ustawień.

// Ten sam próg co na serwerze (MAKS_DLUGOSC_PLIKU): certyfikat i klucz mają kilka kilobajtów.
export const MAKS_ROZMIAR_PLIKU = 100 * 1024;

export function zawartoscPlikuKsef(bajty) {
  let binarny = '';
  for (let i = 0; i < bajty.length; i += 0x8000) {
    binarny += String.fromCharCode.apply(null, bajty.subarray(i, i + 0x8000));
  }
  return binarny.includes('-----BEGIN') ? binarny : btoa(binarny);
}

export function czytajPlikKsef(plik) {
  return new Promise((resolve, reject) => {
    if (!plik) { reject(new Error('no file')); return; }
    if (plik.size > MAKS_ROZMIAR_PLIKU) { reject(Object.assign(new Error('file too large'), { zaDuzy: true })); return; }
    const czytnik = new FileReader();
    czytnik.onload = () => resolve(zawartoscPlikuKsef(new Uint8Array(czytnik.result)));
    czytnik.onerror = () => reject(czytnik.error || new Error('read error'));
    czytnik.readAsArrayBuffer(plik);
  });
}
